import { DeviceType } from "src/globalTypes/device";
import { TemplateId } from "../../globalTypes";

export const fetchFunctionsSelectList = (id: TemplateId): string =>
  `api/DataPresentation/GetFunctionsSelectList?templateId=${id}`;

export const loginWithCookie = (): string => `api/UserAccount/LoginWithCookie`;

export const login = (): string => `api/UserAccount/NEWLogin`;

export const logout = (): string => `api/UserAccount/Logout`;

export const googleLogin = (token: string, deviceType: DeviceType): string =>
  `api/UserAccount/GoogleLogin?token=${token}&deviceType=${deviceType}`;

export const resetLoginCookieKey = (key: string): string =>
  `api/UserAccount/ResetLoginCookieKey?key=${key}`;

export const googleLoginClientId = (): string =>
  `api/UserAccount/GetGoogleLoginClientId`;

export const getAvailableLoginProviders = (): string =>
  `api/UserAccount/GetAvailableLoginProviders`;

export const activeDirectoryLogin = (): string => `api/UserAccount/LdapLogin`;

export const isUserAdmin = (): string => `api/UserAccount/IsUserAdmin`;

export const microsoftLogin = (): string =>
  `api/UserAccount/MicrosoftTokenLogin`;
